import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { AiOutlineClose } from "react-icons/ai";
const UnsubscribeModal = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        sx={{
          fontWeight: 700,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Unsubscribe Keys
        <IconButton onClick={onClose}>
          <AiOutlineClose />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ bgcolor: "#F9FAFB" }}>
        <Typography color="#6B7280">
          This feature allows you to configure keywords that unsubscribe users
          from message flows.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose} sx={{ bgcolor: "#25D366" }}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default UnsubscribeModal;